import {
  useLockDirectoryRecord,
  useSaveDirectoryRecordStatus,
} from 'api/requests';
import { PermissionType } from 'api/types/entity';
import { useServerErrorNotify } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { useNotify } from 'libs/notify';
import { usePermissions } from 'libs/permissions';

interface ArchiveProps {
  id: string;
  versionNumber?: number;
}

export const useDirectoryRecordArchive = () => {
  const notify = useNotify();
  const { t } = useTranslation();
  const { checkPermissions } = usePermissions();

  const { saveStatus, error: errorSaveStatus } = useSaveDirectoryRecordStatus();
  const { lock, error: errorLock } = useLockDirectoryRecord();

  const onArchiveRecord = checkPermissions([
    PermissionType.Directory_ArchiveOne,
  ])
    ? async (record: ArchiveProps) => {
        if (record.versionNumber) {
          if (await lock(record.id, record.versionNumber)) {
            await saveStatus(record.id, record.versionNumber, 'Archived');
            notify.info(t('common.archivedMessage'));
          }
        }
      }
    : undefined;

  const onDearchiveRecord = checkPermissions([
    PermissionType.Directory_ArchiveOne,
  ])
    ? async (record: ArchiveProps) => {
        if (record.versionNumber) {
          if (await lock(record.id, record.versionNumber)) {
            await saveStatus(record.id, record.versionNumber, 'Active');
            notify.info(t('common.dearchivedMessage'));
          }
        }
      }
    : undefined;

  useServerErrorNotify(errorLock || errorSaveStatus);

  return {
    onArchiveRecord,
    onDearchiveRecord,
  };
};
